import React from 'react';

// TODO UniFormgenHtmlTagText single HTML tag with text
/*
https://developer.mozilla.org/en-US/docs/Web/HTML/Guides/Content_categories#phrasing_content
Phrasing content
Phrasing content, a subset of flow content, refers to the text and the markup within a document. Sequences of phrasing content make up paragraphs.
*/

const UniFormgenHtmlTagText = (props) => {
  let params = {};
  if (props.params) {
    params = props.params;
  }
  let title = params.title;

  let cl = 'uniformcompo__html-single-tag-with-text';
  // let extraClass = '';
  if (typeof params.extraclass === 'string' && params.extraclass !== '') {
    // extraClass = ' ' + params.extraclass;
    cl += ' ' + params.extraclass;
  }


  let tag = params.tag;
  let jsx = null;
  switch (tag) {
    case 'p':
      jsx = (<p className={cl}>{title}</p>);
      break;
    case 'h1':
      jsx = (<h1 className={cl}>{title}</h1>);
      break;
    case 'h2':
      jsx = (<h2 className={cl}>{title}</h2>);
      break;
    case 'h3':
      jsx = (<h3 className={cl}>{title}</h3>);
      break;
    case 'h4':
      jsx = (<h4 className={cl}>{title}</h4>);
      break;
    case 'h5':
      jsx = (<h5 className={cl}>{title}</h5>);
      break;
    case 'div':
      jsx = (<div className={cl}>{title}</div>);
      break;
    case 'span':
      jsx = (<span className={cl}>{title}</span>);
      break;
    default:
      jsx = (<p className={cl}>{title}</p>);
  }

  return (
    <>
      {jsx}
    </>
  );
};

export default UniFormgenHtmlTagText;